"use client";

import React, { useState, Suspense } from "react";

import { ExclusiveGalleryProps } from "@interfaces/gallery";
import dynamic from "next/dynamic";

import { LoadMoreButton } from "@components/atoms/LoadMoreButton.tsx/LoadMoreButton";

import {
  getPaginatedImages,
  hasMoreExclusiveImages,
} from "@utils/gallery-utils";

import { useAppSelector } from "@lib/redux/hooks";
import styles from "./styles.module.scss";
// Dynamically import ImageGrid with loading fallback
const ImageGrid = dynamic(
  () =>
    import("@components/molecules/ImageGrid/ImageGrid").then(
      (mod) => mod.ImageGrid
    ),

  {
    loading: () => <div className={styles["exclusive-gallery__loading"]} />,
  }
);

export const ExclusiveGallery = ({
  images,
  modelName,
  isLoggedIn = false,
}: ExclusiveGalleryProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const displayedImages = getPaginatedImages(images, currentPage);
  const showLoadMore = hasMoreExclusiveImages(images, currentPage);

  const handleLoadMore = () => {
    setCurrentPage((prev) => prev + 1);
  };
  return (
    <section className={styles["exclusive-gallery"]}>
        <div className={styles["exclusive-gallery__container"]}>
        <h2 className={styles["exclusive-gallery__title"]}>
           {modelName} - Exclusive Gallery
          </h2>
          {!isLoggedIn && (
            <p className={styles["exclusive-gallery__description"]}>
              Unlock a gallery of exclusive, expert-shot {modelName} images that
              capture every stunning detail
            </p>
          )}

          <Suspense
            fallback={<div className={styles["exclusive-gallery__loading"]} />}
          >
            <ImageGrid images={displayedImages} isLoggedIn={isLoggedIn} />
          </Suspense>

          {isLoggedIn && showLoadMore && (
            <div className={styles["exclusive-gallery__load-more"]}>
              <LoadMoreButton onClick={handleLoadMore} />
            </div>
          )}
        </div>
    </section>
  );
};
